
import React from 'react';
import { Button } from '@/components/ui/button';
import LoadingHeader from '@/components/loading/LoadingHeader';
import ProgressDisplay from '@/components/loading/ProgressDisplay';
import CrawlStagesList from '@/components/loading/CrawlStagesList';
import SecurityNotice from '@/components/loading/SecurityNotice';
import { useFavicon } from '@/hooks/useFavicon';
import { getCrawlStages } from '@/utils/crawlStageUtils';

interface LoadingStateProps {
  progress: number;
  stage: string;
  pagesProcessed: number;
  totalPages: number;
  onCancel: () => void;
  websiteUrl: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  progress,
  stage,
  pagesProcessed,
  totalPages,
  onCancel,
  websiteUrl
}) => {
  const favicon = useFavicon(websiteUrl);
  
  // Get crawl stages based on current progress and stage name
  const crawlStages = getCrawlStages(stage, progress);
  
  return (
    <div className="w-full max-w-xl py-10 px-6 floating-card animate-slide-up">
      <LoadingHeader 
        websiteUrl={websiteUrl}
        favicon={favicon}
        onCancel={onCancel}
      />

      <div className="space-y-6">
        <ProgressDisplay 
          progress={progress}
          stage={stage}
          pagesProcessed={pagesProcessed}
          totalPages={totalPages}
        />

        <CrawlStagesList 
          stages={crawlStages}
          progress={progress}
        />
        
        <SecurityNotice showNotice={progress > 60} />
        
        <Button
          variant="outline"
          onClick={onCancel}
          className="w-full mt-4"
        >
          Cancel Analysis
        </Button>
      </div>
    </div>
  );
};

export default LoadingState;
